import { motion, useScroll, useSpring } from "framer-motion";

// 2px brass bar at the very top — draws itself as the page moves.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 30,
    mass: 0.35,
  });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="pointer-events-none fixed inset-x-0 top-0 z-[75] h-[2px] origin-left bg-gold/80"
      style={{ scaleX }}
    />
  );
}
